import PremiumBenefitsBlock from 'components/PremiumBenefitsBlock';
import React, { FC, memo, useCallback, useState } from 'react';
import Plan from './Plan';
import {
  Container,
  Plans,
  PremiumTabCorporate,
  PremiumTabIndividual,
  PremiumTypeTabs,
  Subtitle,
  TabText,
  Title,
  Wrapper,
} from './styles';
import { Props } from './types';

const Pricing: FC<Props> = ({ isAlreadyPremium, plans, ...rest }) => {
  const [isCorporate, setIsCorporate] = useState(false);

  const setCorporateValueTrue = useCallback(() => setIsCorporate(true), [
    setIsCorporate,
  ]);
  const setCorporateValueFalse = useCallback(() => setIsCorporate(false), [
    setIsCorporate,
  ]);

  const getPlanPeriod = useCallback((period: string) => {
    switch (period) {
      case 'month':
        return 'Monthly';
      case 'year':
        return 'Annual';
      default:
        return 'Lifetime';
    }
  }, []);

  return (
    <Container {...rest}>
      <Wrapper>
        <Title>Choose a plan</Title>
        <Subtitle>
          Become a premium member and get unlimited access to resources you
          won’t find anywhere else.
        </Subtitle>
        <PremiumTypeTabs>
          <PremiumTabIndividual
            $activeTab={!isCorporate}
            onClick={setCorporateValueFalse}
          >
            <TabText $activeTab={!isCorporate}>Individual Plan</TabText>
          </PremiumTabIndividual>
          <PremiumTabCorporate
            $activeTab={isCorporate}
            onClick={setCorporateValueTrue}
          >
            <TabText $activeTab={isCorporate}>Group Plan</TabText>
          </PremiumTabCorporate>
        </PremiumTypeTabs>
        <Plans>
          {plans
            .filter((plan) => plan.metadata?.disabled === 'false')
            .map(
              (plan, i) =>
                !(!plan.period && isCorporate) && (
                  <Plan
                    disabled={isAlreadyPremium}
                    id={plan.id}
                    index={i}
                    isCorporate={isCorporate}
                    key={plan.id}
                    period={getPlanPeriod(plan.period)}
                    price={plan.price}
                    savings={plan.savings}
                    subtitle={
                      isCorporate
                        ? `per seat per ${plan.period}`
                        : plan.period
                        ? `per ${plan.period}`
                        : 'one time'
                    }
                  />
                ),
            )}
        </Plans>
      </Wrapper>
      <PremiumBenefitsBlock />
    </Container>
  );
};

export default memo(Pricing);
